import { Component, OnInit, ViewChild } from "@angular/core";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import { DashService } from "./dashboard.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {
  public columnsDeudores: ListColumn[] = [
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Saldo",
      property: "Saldo",
      visible: true,
      isModelProperty: true,
    },
  ];
  public columnsMaterial: ListColumn[] = [
    {
      name: "Descripcion",
      property: "Descripcion",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Saldo",
      property: "Saldo",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Minimo",
      property: "Minimo",
      visible: true,
      isModelProperty: true,
    },
  ];

  deudoresList: any[] = [];

  @ViewChild("tableDeudores", { static: false })
  public tableDeudores: CardTableComponent;
  @ViewChild("tableDeudores") set contentDeudores(content: CardTableComponent) {
    if (content) {
      // initially setter gets called with undefined
      this.tableDeudores = content;
      this.tableDeudores?.setData(this.deudoresList);
    }
  }
  materialsList: any[] = [];
  @ViewChild("tableMaterial", { static: false })
  public tableMaterial: CardTableComponent;
  @ViewChild("tableMaterial") set content(content: CardTableComponent) {
    if (content) {
      // initially setter gets called with undefined
      this.tableMaterial = content;
      this.tableMaterial?.setData(this.materialsList);
    }
  }
  resumen: any = null;
  showResumen: boolean = false;
  showDeudores: boolean = false;
  showMaterialesRojos: boolean = false;
  constructor(public serv: DashService) {}

  ngOnInit() {
    this.serv.get().subscribe((data: any) => {
      if (data.Resumen) {
        this.showResumen = true;
        this.resumen = data.Resumen;
      }
      if (data.Deudores) {
        this.showDeudores = true;
        this.deudoresList = data.Deudores;
      }
      if (data.MaterialesRojos) {
        this.showMaterialesRojos = true;
        this.materialsList = data.MaterialesRojos;
      }
    });
  }
}
